module.exports = __webpack_public_path__ + "static/img/jd2.16d4a046.png";